export default "__VITE_ASSET__947d2f26__"